import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { Box, Radio } from '@chakra-ui/react';
import { jsx as _jsx } from "react/jsx-runtime";
function getBorderRadius(listIndex) {
  switch (listIndex) {
    case 0:
      return 'var(--chakra-space-1) var(--chakra-space-1) 0 0';
    case 'last':
      return '0 0 var(--chakra-space-1) var(--chakra-space-1)';
    case 'left':
      return 'var(--chakra-space-1) 0 0 var(--chakra-space-1)';
    case undefined:
      return '4';
    default:
      return '0';
  }
}
function getBorderWidth(isBorderless, isChecked) {
  if (isBorderless) {
    return 0;
  }
  if (isChecked) {
    return '2px';
  }
  return '1px';
}
function getBorderBottomWidth(isBorderless, isChecked, listIndex) {
  if (isBorderless) {
    return 0;
  }
  if (isChecked) {
    return '2px';
  }
  if ([undefined, 0, 'last', 'left'].includes(listIndex)) {
    return '1px';
  }
  return 0;
}
var radioButtonStyle = function radioButtonStyle(isBorderless, isChecked, listIndex, padding, borderColorChecked, backgroundColorChecked) {
  var withOutline = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : false;
  if (withOutline) {
    return {
      outline: isChecked ? '4px solid var(--chakra-colors-primary)' : '',
      outlineOffset: '-4px',
      borderWidth: getBorderWidth(isBorderless, false),
      borderColor: 'lightGrey1',
      borderRadius: getBorderRadius(listIndex),
      p: isBorderless || padding ? '0' : 'md'
    };
  } else return {
    borderWidth: getBorderWidth(isBorderless, isChecked),
    borderBottomWidth: getBorderBottomWidth(isBorderless, isChecked, listIndex),
    borderStyle: 'solid',
    borderColor: isChecked ? borderColorChecked !== null && borderColorChecked !== void 0 ? borderColorChecked : 'primary' : 'lightGrey1',
    backgroundColor: isChecked ? backgroundColorChecked !== null && backgroundColorChecked !== void 0 ? backgroundColorChecked : 'transparent' : 'transparent',
    borderRadius: getBorderRadius(listIndex),
    p: isBorderless || padding ? '0' : 'md'
  };
};
export default function RadioButton(props) {
  var _props$withOutline;
  return _jsx(Box, _objectSpread(_objectSpread({
    "data-testid": props.type ? "radio-box-wrapper_".concat(props.type) : 'radio-box-wrapper'
  }, radioButtonStyle(props.variant === 'borderless', props.isChecked, props.listIndex, props.padding, props.borderColorChecked, props.backgroundColorChecked, (_props$withOutline = props.withOutline) !== null && _props$withOutline !== void 0 ? _props$withOutline : false)), {}, {
    width: props.width,
    children: _jsx(Radio, _objectSpread(_objectSpread({
      "data-testid": props.type ? "radio-box-inside_".concat(props.type) : 'radio-box-inside',
      alignItems: "flex-start",
      width: "full"
    }, props), {}, {
      children: props.children
    }))
  }));
}